const trans = (key, parameters = {}, fallback = key) => {
    if (!window.Translator) return fallback;
    const translation = window.Translator.trans(key, parameters);
    return translation === key ? fallback : translation;
};

export default trans;
